Controller = App.loadClass 'core::Angular/Controller'

class exports.ZonesDropdownTableController extends Controller

    constructor: (@scope, @transitions, @zone_type, option_name, option_type, options, @validation, @pgis, @zones_service) ->
        # prevent errors when refreshing or navigating directly to this step
        if not @pgis.field_data? and not @validation.canContinue()
            return

        @scope.disabled.back = false

        # location of field data may change depending on entry point
        @scope.field_data = if @pgis?.field_data? then @pgis.field_data else @validation.getFieldData()

        # set the zone (could be dynamic if ever needed, see how zones radio settings controller works)
        @scope.zone = @scope.field_data.zones[@zone_type]

        # reset mappings if we are editing an old zone
        if @scope.zone.extra_info?.mappings?
            @scope.zone.extra_info.mappings = []
        else if not @scope.zone.extra_info?
            # set defaults according to template
            @scope.zone.extra_info = {
                crop: null
                units: "bu/ac"
                name_add: null
                mappings: []
            }

        # set the zone type
        @scope.zone.zone_type = @zone_type
        @scope.zone_type = @zone_type

        # set flag
        @scope.field_data.visited_settings = true

        # setup validation
        @scope.validation = @validation
        @scope.validate = @validate
        @scope.validation.setStepScope(@scope)

        @transitionStart = @transitions.onStart {}, ($transition) =>
            if @zone_type is 'irrigation'
                @pgis.setIrrigationZone(@scope.zone)
            if @zone_type is 'previous-crop'
                @pgis.setPreviousCropZone(@scope.zone)
            if @zone_type is 'productivity'
                @pgis.setProductivityZone(@scope.zone)

            if _.startsWith($transition.to().name, 'grower.fields-define')
                @scope.died_willingly = true

            # remove layers if we are on the last step for the zone
            if @scope.zone_type is 'previous-crop'
                for z in @scope.zone.zones
                    # clear layer from map
                    App.map.removeLayer z.visible

                # clear stored data for the next zone
                @pgis.setFieldData(null)
                @pgis.setZoneObject(null)

        @scope.$parent.steps.once 'switch-from', "grower.fields-define.#{@zone_type}-settings1", (data) =>
            if data.is_forward
                # reset it for the next zone
                @scope.field_data.visited_settings = null
                @validation.setFieldData(@scope.field_data)

        @scope.$on '$destroy', () =>
            if not @scope.died_willingly
                # clear layers
                @validation.clearLayers()
                # clear settings
                @validation.settings = {}

            @transitionStart()

        @zones_service.crops().then (crops) =>
            # add the divider
            crops.push
                name: '---------------'
                id: -1
                unused: false
                is_divider: true

            @scope.crops = crops

        # the zone areas may or may not be on the map depending on entry point
        @pgis.addZonesToMapIfNeeded(@scope.zone)
        @scope.validation.validate()
        @validation.setBackButtonDisable(@scope.field_data, false)

    validate: (ending) =>
        # ensure that each input has a value selected
        @validation.setFieldData(@scope.field_data)

        for area in @scope.zone.zones when not area.value?
            return false

        return true
